import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const WorldPreview: React.FC = () => {
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <div className="preview-page">
      <div className="preview-split">
        <div className="preview-copy">
          <p className="preview-eyebrow">World Building</p>
          <h2 className="preview-headline">Every character, place, and event — connected.</h2>
          <p className="preview-body">
            Build your world visually. Create characters, locations, and events, then map
            the relationships between them on an interactive canvas.
          </p>
          <ul className="preview-bullets">
            <li>Character, location &amp; event cards</li>
            <li>Interactive relationship canvas</li>
            <li>Filter by book or series</li>
            <li>Visual relationship mapping</li>
          </ul>
          <Link to="/pricing" className="btn-primary">Subscribe to unlock →</Link>
        </div>

        <div className="preview-image">
          {!imgFailed && (
            <img
              src="/img/world-preview.png"
              alt="Character cards on the relationship canvas, joined by labelled relationships"
              onError={() => setImgFailed(true)}
            />
          )}
          {imgFailed && (
            <div className="preview-image-placeholder">
              <span>🗺️</span>
              <p>Screenshot coming soon</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WorldPreview;
